const validate = values => {
  const errors = {};

  if (!values.startingDate && !values.multiDates?.startDate && !values?.multiDates?.endDate) {
    errors.multiDates = 'Dates are required';
    errors.startingDate = 'Starting date is required';
  }

  return errors;
};

export default validate;
